// removed by extract-text-webpack-plugin
module.exports = {"pressure":"_3U45VrKwWFvBPXsRurZyJW","caption":"ONh-LM5ci83L7z8_lnRSA","wrap":"_3dHf0_-D_Ko8QxyYEHuQlr","On":"_1TmwGj8bI1lo2T4V4W9aRI","avar":"_3e336SHvyvYhGZdy-v4e2J","blink":"xBzn59RCSFn6BikW-tbly","disabled":"KBY-jmpB5kdXvCYb2ltC1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/entries/PressureE/style.css
// module id = 340
// module chunks = 0